export default __webpack_public_path__ + "vimeo-square-logo.png";